export default __webpack_public_path__ + "static/media/logo-esquerda.81857d0a.jpg";